import styles from "./JoinUnavailable.module.scss";

import {
  ErrorComponent,
  type ErrorComponentProps,
  useRouter,
  useRouterState,
} from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { AppButton } from "@/modules/shared/components/AppButton";
import { PageContainer } from "@/modules/shared/components/PageContainer";
import { isFetchNetworkError } from "@/modules/shared/utils/reactQueryErrorTracking";

export const JoinUnavailable = ({ error }: ErrorComponentProps) => {
  const { t } = useTranslation();
  const router = useRouter();
  const isRetrying = useRouterState({ select: (state) => state.isLoading });

  // Only connection failures can be fixed by retrying; anything else keeps the
  // router's default error display.
  if (!isFetchNetworkError(error)) {
    return <ErrorComponent error={error} />;
  }

  return (
    <PageContainer>
      <div className={styles.container}>
        <h1 className={styles.title}>
          {t("coachingSession.join.unavailable.title")}
        </h1>
        <p className={styles.subtitle}>
          {t("coachingSession.join.unavailable.subtitle")}
        </p>
        <AppButton
          onClick={() => {
            void router.invalidate();
          }}
          isLoading={isRetrying}
        >
          {t("coachingSession.join.unavailable.retry")}
        </AppButton>
      </div>
    </PageContainer>
  );
};
